module.exports = __webpack_public_path__ + "static/media/Settings.18cfde4b.svg";